export default defineNuxtPlugin((nuxtApp) => {
  const segment = {
    initBaseEvents: (user, permissions) => {
      if (window.analytics) {
        window.analytics.identify(user.id, {
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
          roles: user.roles,
          states: user.states,
          permissions,
          screenWidth: window.screen.availWidth,
          screenHeight: window.screen.availHeight,
        })

        const agency = user.agency

        window.analytics.group(agency.id, {
          shortID: agency.shortID,
          name: agency.name,
          email: agency.notificationEmail,
          phone: agency.phone,
          streetLine1: agency.streetLine1,
          streetLine2: agency.streetLine2,
          city: agency.city,
          state: agency.state,
          zip: agency.zip,
          appointedStates: agency.appointedStates,
        })
      }
    },
    sendPageEvent: () => {
      const fullPath = nuxtApp.$router.currentRoute.value.fullPath

      // this grabs the current routes search, window.location.search grabs previous search state
      const searchVal = fullPath.split('?')[1]

      // title currently populates with previous routes data, for now we can leave as an empty string
      window.analytics.page({
        path: nuxtApp.$router.currentRoute.value.path,
        // TODO: Verify that this history state check is valid to replace the from path.
        // referrer: `${window.location.origin}${nuxtApp.ctx.from.fullPath}`,
        referrer: `${window.location.origin}${nuxtApp.$router.options.history.state.back}`,
        search: searchVal ? `?${searchVal}` : '',
        title: '',
        url: `${window.location.origin}${fullPath}`,
      })
    },
  }

  return {
    provide: {
      segment,
    },
  }
})
